import * as Sentry from "@sentry/vue";

const HISTORY_METHODS = ["pushState", "replaceState"];

// vue-router retombe sur location.replace()/assign() quand pushState/replaceState lève (SecurityError
// dans certaines webviews intégrées, iPad notamment). Comme le premier chargement appelle toujours
// replaceState, chaque rechargement relance le même échec : la page de login boucle indéfiniment.
// Absorber l'erreur garde l'application utilisable, seule l'URL affichée n'est plus mise à jour.
export function guardHistory(history = window.history) {
  let reported = false;

  HISTORY_METHODS.forEach((method) => {
    const original = history[method].bind(history);
    history[method] = (...args) => {
      try {
        return original(...args);
      } catch (error) {
        if (!reported) {
          reported = true;
          Sentry.captureException(error, { tags: { historyMethod: method } });
        }
      }
    };
  });
}
